<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span>{{ '+SRC_COMMISSIONINGV2.ADD_COMPONENT_HEADER' | translate }}</span>
      <button
        gtm="onConfirm"
        gtmAction="Close"
        gtmCategory="pairingResultModal"
        mat-icon-button
        (click)="closeDialog()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="content__body">
      <ng-container *ngIf="isSuccess; then success; else error"></ng-container>
    </div>
  </mat-card-content>
</mat-card>

<ng-template #success>
  <img class="body__icon" src="assets/img/check_circle.svg" />
  <div class="body__title">{{ '+SRC_COMMISSIONINGV2.PAIRING_SUCCESS_TITLE' | translate }}</div>
  <div class="body__description">
    {{
      '+SRC_COMMISSIONINGV2.PAIRING_SUCCESS_DESCRIPTION'
        | translate: { device: deviceName | translate }
    }}
  </div>

  <div class="body__actions">
    <ng-container
      *ngrxLet="installationFeaturesStore.isVicareThermostatMode() as isVicareThermostatMode"
    >
      <button
        *ngIf="
          !isVicareThermostatMode &&
          deviceType !== RemoteDeviceType.CS_REPEATER &&
          deviceType !== RemoteDeviceType.REPEATER &&
          deviceType !== RemoteDeviceType.VITOTROL_100E
        "
        gtm="onConfirm"
        gtmAction="Navigate Forward"
        gtmCategory="pairingResultModal"
        data-at-result-modal-next-btn
        mat-raised-button
        color="primary"
        (click)="navigateForward()"
      >
        {{ '+SRC_COMMISSIONINGV2.CONTINUE_SETUP' | translate }}
      </button>
      <button
        *ngIf="
          isVicareThermostatMode ||
          deviceType === RemoteDeviceType.CS_REPEATER ||
          deviceType === RemoteDeviceType.REPEATER
        "
        data-at-result-modal-close-btn
        mat-stroked-button
        gtm="onCancelDialog"
        gtmAction="Close"
        gtmCategory="finalResultsModal"
        color="primary"
        (click)="closeDialog()"
      >
        {{ '+SRC_COMMISSIONINGV2.CLOSE_WINDOW' | translate }}
      </button>
    </ng-container>
  </div>
</ng-template>

<ng-template #error>
  <img class="body__icon" src="assets/img/mark_circle.svg" />
  <div class="body__title">{{ '+SRC_COMMISSIONINGV2.PAIRING_ERROR_TITLE' | translate }}</div>

  <div class="body__description">
    {{ getErrorMessage() }}
  </div>

  <div class="body__actions">
    <button
      gtm="onCancelDialog"
      gtmAction="On try again"
      gtmCategory="pairingResultModal"
      data-at-result-modal-next-btn
      mat-raised-button
      color="primary"
      (click)="onTryAgain()"
    >
      {{ '+SRC_COMMISSIONINGV2.PAIRING_RETRY' | translate }}
    </button>
  </div>
</ng-template>
